// loadSkillTool.js — DeerFlow borrow #2 (carga progressiva de skills).
//
// O Worker injeta só um HEADER da skill grande no serverPrompt (explicitSlashSkills
// modo lazy) — o corpo (~dezenas de KB) fica atrás desta tool: o agente chama
// load_skill({"name":"tastedesign"}) NO TURNO em que vai executar a skill e recebe o
// playbook completo como tool result (paga o custo UMA vez, só quando precisa —
// antes o corpo cru entrava em CADA chamada LLM do turno). Read-only: sem gate.

import { apiFetch } from './api.js';

export const LOAD_SKILL_DEF = {
  type: 'function',
  function: {
    name: 'load_skill',
    description:
      'Carrega o playbook COMPLETO de uma skill invocada (o prompt só tem o resumo). '
      + 'Chame UMA vez, ANTES de executar a tarefa da skill, com o nome exato indicado '
      + 'no header "Skill invocada". Ex: {"name":"tastedesign"}.',
    parameters: {
      type: 'object',
      properties: {
        name: { type: 'string', description: 'nome exato da skill (do header no prompt)' },
      },
      required: ['name'],
    },
  },
};

/** Busca o corpo no Worker; devolve string modelo-facing (nunca lança). */
export async function executeLoadSkill(args) {
  const name = typeof args?.name === 'string' ? args.name.trim() : '';
  if (!name) return 'Erro: load_skill exige {"name":"<nome da skill>"} não vazio.';
  const res = await apiFetch(`/api/skills/${encodeURIComponent(name)}`);
  if (!res.ok) return `Erro: skill "${name}" não encontrada (${res.error || 'rede/auth'}). Use o nome EXATO do header.`;
  const content = res.data?.skill?.content;
  if (typeof content !== 'string' || !content.trim()) return `Erro: skill "${name}" existe mas está sem conteúdo.`;
  return `[playbook da skill "${name}" — siga estas instruções na tarefa atual]\n${content}`;
}

/** extraTool load_skill — read-only, disponível em toda sessão local. */
export function resolveLoadSkillTools() {
  return [{
    def: LOAD_SKILL_DEF,
    execute: (args) => executeLoadSkill(args),
  }];
}
